import { useQuery } from '@tanstack/react-query';
import { dashboardApi } from '@/data/api/dashboardApi';
export function useDashboard(fecha, balanceDias = 7) {
    return useQuery({
        queryKey: ['dashboard', fecha ?? 'hoy', balanceDias],
        queryFn: () => dashboardApi.resumen(fecha, balanceDias),
        staleTime: 60_000,
    });
}
export function useDashboardPromotor(opts) {
    return useQuery({
        queryKey: ['dashboard', 'promotor', opts.fecha ?? 'hoy'],
        queryFn: () => dashboardApi.promotor(opts.fecha),
        staleTime: 60_000,
        enabled: opts.habilitado,
    });
}
